module.exports = __webpack_public_path__ + "img/how_to_film.44a38f00.png";